import { forwardRef } from 'react'
import { motion } from 'framer-motion'
import { cn } from '@/utils/helpers'

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  hover?: boolean
  selected?: boolean
  children: React.ReactNode
}

const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ hover = false, selected = false, className, children, ...props }, ref) => {
    const Component = hover ? motion.div : 'div'

    return (
      <Component
        ref={ref as any}
        className={cn(
          'card',
          hover && 'card-hover',
          selected && 'border-primary-500 bg-primary-500/5',
          className
        )}
        {...(hover && {
          whileHover: { y: -4 },
          transition: { duration: 0.2 },
        })}
        {...(props as any)}
      >
        {children}
      </Component>
    )
  }
)

Card.displayName = 'Card'

export default Card
